import { DrawerFormHeaderProps } from './drawer-form-header.type';

/**
 * Flat fixed header for the offer-chassis form drawers: a bottom-bordered row with the title and an
 * optional right slot. Pairs with `DrawerFormLayout` (as its `header`) + `DrawerFormFooter`.
 */
export const DrawerFormHeader = ({ title, rightSlot }: DrawerFormHeaderProps): JSX.Element => (
  <header className='flex items-center justify-between gap-4 border-b border-extra-soft px-4 py-5 xs:px-10 xs:py-6'>
    <h2 className='truncate text-xl font-bold'>{title}</h2>
    {rightSlot}
  </header>
);
